import { render, staticRenderFns } from "./favorites-content.vue?vue&type=template&id=2e7f949a&"
import script from "./favorites-content.vue?vue&type=script&lang=js&"
export * from "./favorites-content.vue?vue&type=script&lang=js&"
import style0 from "./favorites-content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports